import { connect } from 'react-redux'

import { getPromoStore, getPromoCampaignIdFromPromoStoreEntry } from 'selectors/promoStoreSelectors'

import { DiscountBanner } from './DiscountBanner'

const mapStateToProps = (state: any) => {
  const promoStore = getPromoStore(state)
  if (!promoStore) return { fallbackCampaignId: '' }

  const basketPromoCode = Object.keys(promoStore)[0]
  const campaignId = getPromoCampaignIdFromPromoStoreEntry(state, basketPromoCode)

  return {
    fallbackCampaignId: String(campaignId),
  }
}

const DiscountBannerContainer = connect(mapStateToProps)(DiscountBanner)
export { DiscountBannerContainer as DiscountBanner }
